import { MarkAsteriskDirectiveModule } from './../directives/mark-asterisk.directive';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';


import { ListErrorsComponent } from './list-errors.component';
import { ShowAuthedDirective } from './show-authed.directive';
import { RepeatValueDirective } from './directives/repeat-value.directive';

import { MessageModule } from 'primeng/message';
import { DialogModule } from 'primeng/dialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AsistenteComponent } from './widget/asistente.component';
import { EstablecimientosComponent } from './widget/establecimientos.component';
import { PrimeNGModule } from './primeng.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    MessageModule,
    DialogModule,
    AutoCompleteModule,
    PrimeNGModule,
    MarkAsteriskDirectiveModule,
  ],
  declarations: [
    ListErrorsComponent,
    ShowAuthedDirective,
    RepeatValueDirective,
    AsistenteComponent,
    EstablecimientosComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    ShowAuthedDirective,
    RepeatValueDirective,
    
    ListErrorsComponent,
    AsistenteComponent,
    EstablecimientosComponent
  ],
  providers : [DatePipe]
})
export class SharedModule {}
